export default __webpack_public_path__ + "static/media/Create-documentation.10a3d5e0.md";